import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { Category, CategoryNode, NewCategory } from '../_models';
import { AppConfig } from 'src/assets/config/config/app-config';
import * as uuid from 'uuid';
@Injectable({ providedIn: 'root' })
export class CategoryService {
    apiUrl: string
    captureApiUrl: string
    constructor(private http: HttpClient,
        private config: AppConfig) {
        this.apiUrl = this.config.getConfig('apiUrl')
        this.captureApiUrl = this.config.getConfig('captureApiUrl')
    }

    getAll(): Observable<Category[]> {
        return this.http.get<Category[]>(this.apiUrl + `/categories?offset=0&limit=200`);
    }

    get(categoryId): Observable<Category> {
        return this.http.get<Category>(this.apiUrl + `/categories/` + categoryId + '?WithChildren=false')
            .pipe(
            ); 
    }

    getCategoryWithChildren(categoryId): Observable<Category> {
        return this.http.get<Category>(this.apiUrl + `/categories/getCategoryWithChildren/` + categoryId)
            .pipe(
            );        
    }

    getTree(): Observable<CategoryNode[]> {
        return this.http.get<CategoryNode[]>(this.apiUrl + `/categories/tree`)
            .pipe()
    }

    getCategoriesEdit(): Observable<Category[]> {
        return this.http.get<Category[]>(this.apiUrl + `/categories/edit?offset=0&limit=500`);
    }

    createCategory(req: any): Observable<any> {
        return this.http.post(this.apiUrl + `/categories/create`, req).pipe((catchError(this.errorHandler))

        )
    }
    updateCategory(req: any): Observable<any> {
        return this.http.put<any>(this.apiUrl + `/categories/update`, req)
            .pipe()
    }

    deleteCategory(payload) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: payload
        }

        return this.http.delete(this.apiUrl + `/categories/delete`, options).pipe(catchError(this.errorHandler('delete Category')))

    }


    private errorHandler<T>(operation = 'operation', result?: T) {
        //alert(JSON.stringify(err));
        //o: T;
        //alert(typeof o);
        return (error: any): Observable<T> => {
          console.error(error); // log to console instead
        //   this.snackBar.open(String(error).replace('error:', 'ERROR:  '), '', {
        //     duration: 5000,
        //   });
          // TODO: better job of transforming error for user consumption
          //this.log(`${operation} failed: ${error.message}`);
          // Let the app keep running by returning an empty result.
          return of(result as T);
          //return result;
        };
      }


    getRedactionProfilesList() {
        return this.http.get<any>(this.captureApiUrl + `document/redact/profile?profileId=all`).pipe()
    }

    getAllFields() {
        return this.http.get<any>(this.captureApiUrl + `document/redact/field?fieldId=all`)
            .pipe()
    }

    createProfilesEntry(payload) {
        return this.http.post<any>(this.captureApiUrl + `document/redact/profile`, payload)
            .pipe()
    }

    updateProfilesEntry(payload) {
        return this.http.put<any>(this.captureApiUrl + `document/redact/profile`, payload) //pass in a profileId when updating
            .pipe()
    }

    deleteMappingEntry(id) {
        return this.http.delete<any>(this.captureApiUrl + `document/redact/mapping?catId=` + id)
            .pipe()
    }

    deleteProfilesEntry(id) {
        return this.http.delete<any>(this.captureApiUrl + `document/redact/profile?profileId=` + id)
            .pipe()
    }

    createCustomField(payload) {
        return this.http.post<any>(this.captureApiUrl + `document/redact/custom-field`, payload)
            .pipe()
    }

    updateCustomField(payload) {
        return this.http.put<any>(this.captureApiUrl + `document/redact/custom-field`, payload)
            .pipe()
    }

    deleteCustomField(payload) {
        return this.http.delete<any>(this.captureApiUrl + `document/redact/custom-field?profileId=` + payload['profileId'] + `&id=` + payload['id'])
            .pipe()
    }

    getAllCustomFields(profileId) {
        return this.http.get<any>(this.captureApiUrl + `document/redact/custom-field?profileId=` + profileId)
            .pipe()
    }

    getCategoryMapping() {
        return this.http.get<any>(this.captureApiUrl + `document/redact/mapping?catId=all`).pipe()
    }

    getCategoryMappingById(id) {
        return this.http.get<any>(this.captureApiUrl + `document/redact/mapping?catId=` + id).pipe()
    }


    getRedactCatMapping(id) {
        return this.http.get<any>(this.captureApiUrl + 'document/redact/mapping?originalId=' + id)
            .pipe();
    }

    createRedactCatMapping(payload) {
        return this.http.post<any>(this.captureApiUrl + 'document/redact/mapping', payload)
            .pipe();
    }

    updateRedactCatMapping(payload) {
        return this.http.put<any>(this.captureApiUrl +'document/redact/mapping', payload)
            .pipe();
    }

}